import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Firebase configuration for creativeaffiliate
const firebaseConfig = {
    apiKey: "AIzaSyC62DeJqbj-SCi1C6214httR3YOEzkYv6A",
    authDomain: "creativeaffiliate.firebaseapp.com",
    projectId: "creativeaffiliate",
    storageBucket: "creativeaffiliate.firebasestorage.app",
    messagingSenderId: "70420341626",
    appId: "1:70420341626:web:21e585600e979dcddeacc3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Connect to emulators in development
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
    import('firebase/auth').then(({ connectAuthEmulator }) => {
        connectAuthEmulator(auth, 'http://localhost:9099');
    });
    import('firebase/firestore').then(({ connectFirestoreEmulator }) => {
        connectFirestoreEmulator(db, 'localhost', 8080);
    });
    import('firebase/functions').then(({ connectFunctionsEmulator }) => {
        connectFunctionsEmulator(functions, 'localhost', 5001);
    });
}

export default app;
